.panel-title {
  & a.collapsed {
    margin-bottom: 0.75rem;
  }
}
